import React from "react";
import {useStores} from "../../../../../../stores";
import {CategoryMenuControllerContext} from "../../../../context/CategoryMenuController.tsx";
import type {DeserializedGridCellParams} from "../../../../../../components/muix-data-grid/MuiXColumnDefinitions.ts";
import type {PartGridGroupModel, PartGridRowModel} from "../CategorizationTableDataModel.ts";
import type {Labels} from "../../../../../../services/classes/Category.ts";
import {
    categoryToLabels,
    categoryToLabelsWithPrefix,
    labelsToCategory
} from "../../../../../../services/classes/Category.ts";
import {
    CategorizationViewOnlyComponent
} from "../../../../../../components/categorization/CategorizationViewOnlyComponent.tsx";
import {
    PartReCategorizationComponent
} from "../../../../../../components/categorization/PartReCategorizationComponent.tsx";
import {isReviewRowOpenForReview} from "../../../../../../services/classes/MatReviewHelpers.ts";
import {plurals} from "../../../../../../utils/js-utils.ts";

type Props = DeserializedGridCellParams<PartGridRowModel>;
// type Props = GridRowParams<PartGridRowModel>;  // In case if used as action
export const CategoryCell: React.FC<Props> = ({row, rowNode}) => {
    const {p, bagStore, categorizationReviewStore} = useStores();
    const cmc = React.useContext(CategoryMenuControllerContext);
    const rpc = categorizationReviewStore.reviewPageController;
    const filterController = rpc.reviewPageFilterController;
    const taxonomySize = bagStore.taxonomy_size;

    if (!row) return null;

    if (rowNode.type === 'group') {
        const groupRow = row as unknown as PartGridGroupModel;

        if (groupRow.cat_id_agg.length === 1) {
            // There is a single category for the group
            const commonCategory: Labels = categoryToLabelsWithPrefix(groupRow, 'cat_common_l', '_agg', taxonomySize, true);
            return <CategorizationViewOnlyComponent category={commonCategory}/>
        }
        const n = groupRow.cat_id_agg.length;
        return `${n} ${plurals(n, 'category', 'categories')}${groupRow.has_uncategorized_agg ? ' and uncategorized' : ''}`;
    }

    if (!row.cat) return null;

    const partRow = row as PartGridRowModel;
    const canEdit = categorizationReviewStore.canEditReviewPage
        && isReviewRowOpenForReview(partRow)
        && !row.isLoading;

    const labels = categoryToLabels(row.cat, taxonomySize, !!p.p.allowIncompleteTaxonomy, !!p.p.hideRepeatingLabels);
    if (!canEdit) {
        return <CategorizationViewOnlyComponent category={labels}/>
    } else {
        return <PartReCategorizationComponent
            cats={labels}
            handleOpenSearch={event => {
                if (!cmc) {
                    console.error('No CategoryMenuControllerContext set');
                    return;
                }

                // When the category component is opened, reset the selection to avoid confusion
                rpc.reviewPageSelectionController.clearSelection();

                const anchor = event.currentTarget;
                cmc.setOnSelect(c => {
                    const category = labelsToCategory(c.data.labels)
                    rpc.reviewPageTableController.onReviewCategory(row.id || String(row.part), category)
                });
                cmc.open(anchor);
            }}
            selectedL1Category={filterController.selectedL1Category}
        />
    }
};
